import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-export-proc-menu',
  templateUrl: './p2-export-proc-menu.component.html',
  styleUrls: ['./p2-export-proc-menu.component.css']
})
export class P2ExportProcMenuComponent implements OnInit {
    p2ExportProcKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2ExportProcKeyno = this.stateService.getStateParams()['p2_exportproc_keyno'];
    }

    private async loadMenu() {
        if (!!this.p2ExportProcKeyno) {
            this.menu = (await this.datatask.Post(1891, { p2_exportproc_keyno: this.p2ExportProcKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    p2_exportproc_keyno: string;
    p2_exportproc_name: string;
    proc_name: string;
}
